import { axiosPrivate } from "../../api/axios";

const saveDesign = async (designData) => {
  try {
    const response = await axiosPrivate.post(`/design/save`, designData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to save design";
  }
};

const getSavedDesigns = async () => {
  try {
    const response = await axiosPrivate.get(`/design/saved`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch saved designs";
  }
};

const deleteDesign = async (designId) => {
  try {
    const response = await axiosPrivate.delete(`/design/${designId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to delete design";
  }
};

const getDesign = async (designId) => {
  try {
    const response = await axiosPrivate.get(`/design/${designId}`);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to fetch design";
  }
};

const updateDesign = async (designId, updateData) => {
  try {
    const response = await axiosPrivate.put(`/design/${designId}`, updateData);
    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to update design";
  }
};

const designService = {
  saveDesign,
  getSavedDesigns,
  deleteDesign,
  getDesign,
  updateDesign,
};

export default designService;
